import React, { useState, useEffect } from 'react';
import Modal                          from 'react-bootstrap/Modal';
import CloseBtn                       from 'assets/icons/Close.svg';
import CancelIcon                     from 'assets/icons/Cancel Icon.svg';
import MoreButton                     from 'assets/icons/More.svg';
import ArrowDown                      from 'assets/icons/Arrow Down.svg';
import RedCheck                       from 'assets/icons/Red Check.svg';
import GreenTick                      from 'assets/icons/Green Tick.svg';
import AsyncSelect                    from 'react-select/async';
import AuthService                    from 'services/auth.service';
import ClaimsService                  from 'services/claims.service';
import queryString                    from 'query-string';
import { formatCurrency }             from 'helpers/common.helper';
import { dateRefClaim, medicalBill, disclaimer } from './ClaimStatics';

export function CreateClaim(props) {
  const [show, setShow]                       = useState(false);
  const [showButtons, setShowButtons]         = useState(true);
  const [displayDraft, setDisplayDraft]       = useState(<div></div>);
  const [displaySubmit, setDisplaySubmit]     = useState(<div></div>);
  const [errorResponse, setErrorResponse]     = useState('');
  const [successResponse, setSuccessResponse] = useState('');
  const [details, setDetails]                 = useState(props.data);
  const [limit, setLimit]                     = useState(47);
  const [balance, setBalance]                 = useState(47);
  const [isGeneral]                           = useState(props.category !== 'Optical');
  const [isOptical]                           = useState(props.category === 'Optical');

  const handleClose = () => {
    setShow(false);
    successResponse.length > 0 && props.triggerReload();
    setSuccessResponse('');
    setShowActions(false);
    setShowButtons(true);
  };

  const handleShow = () => {
    setShow(true);

    ClaimsService.show(details.id).then(
      (data) => {
        setDetails(data.claim);
        setLimit(data.claim.claim_limit);
        setBalance(data.meta.credit_balance);
      },
      (error) => {
        console.log(error.response);

        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        } else if (error.response.status === 404) {
          handleClose();
          alert('Claim ID: ' + details.id + ' not found');
          props.triggerReload();
        }
      }
    );
  };

  // Query to retrieve list of diagnosis, services and medications.
    const queryAssociations = (type, query) => {
      if (query.length === 0) { return [] }

      const parameters = queryString.stringify({
        association_type: type,
        query: query,
        per: 50,
        page: 1
      });

      return ClaimsService.associationList(details.id, parameters).then(
        (data) => {
          return data.result.map((hash) => {
            return { value: hash.id, label: hash.name, amount: 0, cost: '0.00', total: '0.00', deleted: false }
          });
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }

  // On page load & after submission for update
    const [grandTotal, setGrandTotal]         = useState(details.total_amount || '0.00');
    const [leaveDays, setLeaveDays]           = useState(details.medical_certificate_days || 0);
    const [doctorNote, setDoctorNote]         = useState(details.provider_notes || '');
    const [diagnosisList, setDiagnosisList]   = useState([]);
    const [showDiagnosis, setShowDiagnosis]   = useState([]);
    const [servicesList, setServicesList]     = useState([]);
    const [showServices, setShowServices]     = useState([]);
    const [medicationList, setMedicationList] = useState([]);
    const [showMedication, setShowMedication] = useState([]);
    const [eyewearsList, setEyewearsList]     = useState([]);
    const [showEyewears, setShowEyewears]     = useState([]);

    useEffect(() => {
      let loadDiagnosisList   = [];
      let loadServicesList    = [];
      let loadMedicationList  = [];
      let loadEyewearList     = [];

      if (details.diagnosis.length > 0) {
        loadDiagnosisList = details.diagnosis.map(function(hash) {
          return { id: hash.id, label: hash.name, deleted: false, value: hash.diagnosis_id }
        });
      }

      if (details.services.length > 0) {
        loadServicesList = details.services.map(function(hash) {
          return { id: hash.id, label: hash.name, deleted: false, value: hash.service_id, cost: formatCurrency(hash.fee) }
        });
      }

      if (details.medications.length > 0) {
        loadMedicationList = details.medications.map(function(hash) {
          const total           = hash.quantity * hash.unit_price;
          return { id: hash.id, label: hash.name, deleted: false, value: hash.medication_id, cost: formatCurrency(hash.unit_price), amount: hash.quantity, total: formatCurrency(total) }
        });
      }

      if (details.eyewears.length > 0) {
        loadEyewearList = details.eyewears.map(function(hash) {
          return { id: hash.id, label: hash.name, deleted: false, value: hash.eyewear_id, cost: formatCurrency(hash.unit_price), note: hash.description }
        });
      }

      setDiagnosisList(loadDiagnosisList);
      setServicesList(loadServicesList);
      setMedicationList(loadMedicationList);
      setEyewearsList(loadEyewearList);
      setGrandTotal(details.total_amount || '0.00');
      setLeaveDays(details.medical_certificate_days || 0);
      setDoctorNote(details.provider_notes || '');
    }, [details]);

  // Round medical cert days to lowest 0.5
    const settingCertDays = (inputValue) => {
      const rounded = (Math.floor(inputValue * 2) / 2).toFixed(1);
      setLeaveDays(rounded);
    }

  // Diagnosis
    const diagnosisOptions = (inputValue) => {
      return queryAssociations('diagnosis', inputValue);
    }

    const onDiagnosisChange = (e) => {
      let newDiagnosisList  = diagnosisList.slice();
      const index           = newDiagnosisList.findIndex(function(hash) { return hash.value === e.value });

      if (index >= 0) {
        newDiagnosisList[index].deleted = false;
      } else {
        newDiagnosisList.push(e);
      }

      setDiagnosisList(newDiagnosisList);
    }

    useEffect(() => {
      const removeRow = (id) => {
        let newDiagnosisList  = diagnosisList.slice();

        newDiagnosisList      = newDiagnosisList.map(function(hash) {
          if (hash.value === id) { hash.deleted = true }
          return hash;
        });

        setDiagnosisList(newDiagnosisList);
      }

      const selectedDiagnosis = diagnosisList.map((hash, index) => {
        return (
          <span className="selected-items d-flex align-items-center py-1" key={ index } deleted={ hash.deleted.toString() }>
            <span className="d-flex align-items-center">
              <img src={ CancelIcon } alt="remove-item" className="w-em-4 mr-3 remove-btn hover-grey" onClick={() => removeRow(hash.value) } />
              <b>{ hash.label }</b>
            </span>
          </span>
        )
      });

      setShowDiagnosis(selectedDiagnosis);
    }, [diagnosisList]);

  // Services
    const servicesOptions = (inputValue) => {
      return queryAssociations('service', inputValue);
    }

    const onServicesChange = (e) => {
      let newServicesList   = servicesList.slice();
      const index           = newServicesList.findIndex(function(hash) { return hash.value === e.value });

      if (index >= 0) {
        newServicesList[index].deleted = false;
      } else {
        newServicesList.push(e);
      }

      setServicesList(newServicesList);
    }

    useEffect(() => {
      const removeRow = (id) => {
        let newServicesList = servicesList.slice();

        newServicesList     = newServicesList.map(function(hash) {
          if (hash.value === id) { hash.deleted = true }
          return hash;
        });

        setServicesList(newServicesList);
      }

      const updateServiceCost = (id, cost) => {
        let newServicesList     = servicesList.slice();
        const index             = newServicesList.findIndex((hash)=> { return hash.value === id });
        let newHash             = newServicesList[index];
        let cleanedCost         = cost;

        if (cost.match(/[^1234567890.]/g)) {
          cleanedCost           = cost.replace(/[^1234567890.]/g, ''); // Only allow numbers and decimals
        }

        newHash.cost            = cleanedCost;
        newServicesList[index]  = newHash;
        setServicesList(newServicesList);
      }

      const setDecimalPlaces = (id, cost) => {
        let newServicesList     = servicesList.slice();
        const index             = newServicesList.findIndex((hash)=> { return hash.value === id });
        let newHash             = newServicesList[index];
        const formattedAmount   = cost.length > 0 ? (parseFloat(cost)).toFixed(2) : '0.00';
        newHash.cost            = formattedAmount;
        newServicesList[index]  = newHash;
        setServicesList(newServicesList);
      }

      const selectedServices = servicesList.map((hash, index) => {
        return (
          <span className="selected-items d-flex align-items-center justify-content-between py-1" key={ index } deleted={ hash.deleted.toString() }>
            <span className="d-flex align-items-center">
              <img src={ CancelIcon } alt="remove-item" className="w-em-4 mr-3 remove-btn hover-grey" onClick={() => removeRow(hash.value) } />
              <b>{ hash.label }</b>
            </span>

            <div>
              <input name={ "service-cost[" + index + "]" } type="text"
                value={ hash.cost }
                onChange={(e) => updateServiceCost(hash.value, e.target.value) }
                onBlur={(e) => setDecimalPlaces(hash.value, e.target.value) }
                className="form-control rounded-pill py-6 w-em-20 text-right"
              />

              <span className="position-absolute ml-4" style={{ marginTop: "-2.3em" }}>MYR</span>
            </div>
          </span>
        )
      });

      setShowServices(selectedServices);
    }, [servicesList]);

  // Medications
    const medicationOptions = (inputValue) => {
      return queryAssociations('medication', inputValue);
    }

    const onMedicationChange = (e) => {
      let newMedicationList = medicationList.slice();
      const index           = newMedicationList.findIndex(function(hash) { return hash.value === e.value });

      if (index >= 0) {
        newMedicationList[index].deleted = false;
      } else {
        newMedicationList.push(e);
      }

      setMedicationList(newMedicationList);
    }

    useEffect(() => {
      const removeRow = (id) => {
        let newMedicationList = medicationList.slice();

        newMedicationList = newMedicationList.map(function(hash) {
          if (hash.value === id) { hash.deleted = true }
          return hash;
        });

        setMedicationList(newMedicationList);
      }

      const updateMedicationCount = (id, count) => {
        let newMedicationList     = medicationList.slice();
        const index               = newMedicationList.findIndex((hash)=> { return hash.value === id });
        let newHash               = newMedicationList[index];
        const cleanedCount        = count.replace(/\..+|\./g, '');
        newHash.amount            = cleanedCount;
        const newTotal            = parseFloat(newHash.cost.replace(/,/g, '')) * cleanedCount;
        newHash.total             = formatCurrency(newTotal);
        newMedicationList[index]  = newHash;
        setMedicationList(newMedicationList);
      }

      const updateMedicationCost = (id, cost) => {
        let newMedicationList     = medicationList.slice();
        const index               = newMedicationList.findIndex((hash)=> { return hash.value === id });
        let newHash               = newMedicationList[index];
        let cleanedCost           = cost;

        if (cost.match(/[^1234567890.]/g)) {
          cleanedCost             = cost.replace(/[^1234567890.]/g, ''); // Only allow numbers and decimals
        }

        newHash.cost              = cleanedCost;
        const formattedAmount     = cleanedCost.length > 0 ? (parseFloat(cleanedCost)).toFixed(2) : '0.00';
        const newTotal            = parseFloat(formattedAmount.replace(/,/g, '')) * newHash.amount;
        newHash.total             = formatCurrency(newTotal);
        newMedicationList[index]  = newHash;
        setMedicationList(newMedicationList);
      }

      const setDecimalPlaces = (id, cost) => {
        let newMedicationList     = medicationList.slice();
        const index               = newMedicationList.findIndex((hash)=> { return hash.value === id });
        let newHash               = newMedicationList[index];
        const formattedAmount     = cost.length > 0 ? (parseFloat(cost)).toFixed(2) : '0.00';
        newHash.cost              = formattedAmount;
        newMedicationList[index]  = newHash;
        setMedicationList(newMedicationList);
      }

      const selectedMedication = medicationList.map((hash, index) => {
        return (
          <span className="selected-items d-block d-lg-flex align-items-center justify-content-between py-1" key={ index } deleted={ hash.deleted.toString() }>
            <span className="d-flex align-items-center flex-grow-1">
              <img src={ CancelIcon } alt="remove-item" className="w-em-4 mr-3 remove-btn hover-grey" onClick={() => removeRow(hash.value) } />
              <b>{ hash.label }</b>
            </span>

            <div className="input-fields d-flex align-items-center justify-content-end flex-shrink-0">
              <input name={ "medication-amount[" + index + "]" } type="number" min="0" step="1"
                value={ hash.amount }
                onChange={(e) => updateMedicationCount(hash.value, e.target.value) }
                className="form-control rounded-pill py-6 w-em-10 flex-shrink-0 mx-1"
              />

              <div>
                <input name={ "medication-cost[" + index + "]" } type="text"
                  value={ hash.cost }
                  onChange={(e) => updateMedicationCost(hash.value, e.target.value) }
                  onBlur={(e) => setDecimalPlaces(hash.value, e.target.value) }
                  className="form-control rounded-pill py-6 w-em-20 text-right flex-shrink-0 mx-1"
                />

                <span className="position-absolute ml-4" style={{ marginTop: "-2.3em" }}>MYR</span>
              </div>

              <span className="w-em-5 flex-shrink-0 ml-1">MYR</span>
              <span className="w-em-12 flex-shrink-0 text-right">{ hash.total }</span>
            </div>
          </span>
        )
      });

      setShowMedication(selectedMedication);
    }, [medicationList]);

  // Eyewears
    const eyewearsOptions = (inputValue) => {
      return queryAssociations('eyewear', inputValue);
    }

    const onEyewearsChange = (e) => {
      let newEyewearsList   = eyewearsList.slice();
      const index           = newEyewearsList.findIndex(function(hash) { return hash.value === e.value });

      if (index >= 0) {
        newEyewearsList[index].deleted = false;
      } else {
        newEyewearsList.push(e);
      }

      setEyewearsList(newEyewearsList);
    }

    useEffect(() => {
      const removeRow = (id) => {
        let newEyewearsList = eyewearsList.slice();

        newEyewearsList     = newEyewearsList.map(function(hash) {
          if (hash.value === id) { hash.deleted = true }
          return hash;
        });

        setEyewearsList(newEyewearsList);
      }

      const updateEyewearCost = (id, cost) => {
        let newEyewearsList     = eyewearsList.slice();
        const index             = newEyewearsList.findIndex((hash)=> { return hash.value === id });
        let newHash             = newEyewearsList[index];
        let cleanedCost         = cost;

        if (cost.match(/[^1234567890.]/g)) {
          cleanedCost           = cost.replace(/[^1234567890.]/g, ''); // Only allow numbers and decimals
        }

        newHash.cost            = cleanedCost;
        newEyewearsList[index]  = newHash;
        setEyewearsList(newEyewearsList);
      }

      const setDecimalPlaces = (id, cost) => {
        let newEyewearsList     = eyewearsList.slice();
        const index             = newEyewearsList.findIndex((hash)=> { return hash.value === id });
        let newHash             = newEyewearsList[index];
        const formattedAmount   = cost.length > 0 ? (parseFloat(cost)).toFixed(2) : '0.00';
        newHash.cost            = formattedAmount;
        newEyewearsList[index]  = newHash;
        setEyewearsList(newEyewearsList);
      }

      const updateEyewearNote = (id, note) => {
        let newEyewearsList     = eyewearsList.slice();
        const index             = newEyewearsList.findIndex((hash)=> { return hash.value === id });
        let newHash             = newEyewearsList[index];
        newHash.note            = note;
        newEyewearsList[index]  = newHash;
        setEyewearsList(newEyewearsList);
      }

      const selectedEyewears = eyewearsList.map((hash, index) => {
        return (
          <div className="selected-items" key={ index } deleted={ hash.deleted.toString() }>
            <span className="d-flex align-items-center justify-content-between py-1">
              <span className="d-flex align-items-center">
                <img src={ CancelIcon } alt="remove-item" className="w-em-4 mr-3 remove-btn hover-grey" onClick={() => removeRow(hash.value) } />
                <b>{ hash.label }</b>
              </span>

              <div>
                <input name={ "eyewear-cost[" + index + "]" } type="text"
                  value={ hash.cost }
                  onChange={(e) => updateEyewearCost(hash.value, e.target.value) }
                  onBlur={(e) => setDecimalPlaces(hash.value, e.target.value) }
                  className="form-control rounded-pill py-6 w-em-20 text-right"
                />

                <span className="position-absolute ml-4" style={{ marginTop: "-2.3em" }}>MYR</span>
              </div>
            </span>

            <textarea name={ "eyewear-note[" + index + "]" } type="area" rows="4"
              placeholder="Description/Prescription/Remarks"
              className="form-control py-3 px-4"
              value={ hash.note }
              onChange={(e) => updateEyewearNote(hash.value, e.target.value) }
              style={{ borderRadius: "1em" }}
            />
          </div>
        )
      });

      setShowEyewears(selectedEyewears);
    }, [eyewearsList]);

  // Grand Total Calculation
    useEffect(() => {
      const serviceTotals     = servicesList.map((hash) => { return hash.deleted ? 0 : parseFloat(hash.cost.replace(/,/g, '')) });
      const medicationTotals  = medicationList.map((hash) => { return hash.deleted ? 0 : parseFloat(hash.total.replace(/,/g, '')) });
      const eyewearTotals     = eyewearsList.map((hash) => { return hash.deleted ? 0 : parseFloat(hash.cost.replace(/,/g, '')) });
      const total             = serviceTotals.reduce((a, b) => a + b, 0) + medicationTotals.reduce((a, b) => a + b, 0) + eyewearTotals.reduce((a, b) => a + b, 0);
      setGrandTotal(formatCurrency(total));
    }, [servicesList, medicationList, eyewearsList]);

  // Submission
    useEffect(() => {
      const handleSubmit = (isDraft) => {
        setErrorResponse('');
        setSuccessResponse('');
        const grand_total_amount = parseFloat(grandTotal.replace(/,/g, ''));

        if (grand_total_amount === 0) {
          setErrorResponse('Not allowed to submit a claim with a Grand Total of 0.00');
          return;
        }

        if (limit !== null && limit < grand_total_amount) {
          setErrorResponse('Claim limit exceeded, total cannot be more than MYR ' + formatCurrency(limit));
          return;
        }

        if (balance !== null && balance < grand_total_amount) {
          setErrorResponse('Credit balance exceeded, total cannot be more than MYR ' + formatCurrency(balance));
          return;
        }

        if (!isDraft && !window.confirm('You will not be able to make changes after you submit. Confirm?')) { return }

        const diagnosesParams = diagnosisList.map(function(hash) {
          return {
            id: hash.id,
            diagnosis_id: hash.value,
            '_destroy': hash.deleted
          }
        });

        const servicesParams = servicesList.map(function(hash) {
          return {
            id: hash.id,
            service_id: hash.value,
            fee: parseFloat(hash.cost.replace(/,/g, '')),
            '_destroy': hash.deleted
          }
        });

        const medicationsParams = medicationList.map(function(hash) {
          return {
            id: hash.id,
            medication_id: hash.value,
            unit_price: parseFloat(hash.cost.replace(/,/g, '')),
            quantity: hash.amount || 0,
            '_destroy': hash.deleted
          }
        });

        const eyewearsParams = eyewearsList.map(function(hash) {
          return {
            id: hash.id,
            eyewear_id: hash.value,
            unit_price: parseFloat(hash.cost.replace(/,/g, '')),
            quantity: 1,
            description: hash.note,
            '_destroy': hash.deleted
          }
        });

        var parameters = {
          "medical_certificate_days": leaveDays || 0,
          "provider_notes": doctorNote,
          "total_amount": grand_total_amount,
          "is_draft": isDraft,
          "medical_bills_diagnoses_attributes": diagnosesParams,
          "medical_bills_services_attributes": servicesParams,
          "medical_bills_medications_attributes": medicationsParams,
          "medical_bill_eyewears_attributes": eyewearsParams
        }

        const successMsg = isDraft ? 'Draft saved' : 'Claims submitted';

        ClaimsService.submitClaim(details.id, parameters).then(
          (data) => {
            setDetails(data.claim);
            setSuccessResponse(successMsg);
            setShowButtons(isDraft);
          },
          (error) => {
            if (error.response.status === 401) {
              AuthService.logout();
              window.location.replace('/eb/login');
            }

            if (error.response.data.error && error.response.data.error[0] === "can't submit a claim with 0 fees, please check your inputs") {
              setErrorResponse('Not allowed to submit a claim with a Grand Total of 0.00');
            } else if (error.response.data.error) {
              setErrorResponse(error.response.data.error[0]);
            }
          }
        );
      }

      setDisplayDraft(
        <button className="btn rounded-pill w-em-26 btn-outline-danger py-3 mr-4" onClick={() => { handleSubmit(true) }}>Save as Draft</button>
      );

      setDisplaySubmit(
        <button className="btn rounded-pill w-em-26 btn-danger py-3 ml-4" onClick={() => { handleSubmit(false) }}>Submit Claim</button>
      );
    }, [grandTotal, leaveDays, doctorNote, diagnosisList, servicesList, medicationList, eyewearsList, limit, balance]); // eslint-disable-line react-hooks/exhaustive-deps

  // Claim limit or credit balance is 0
    useEffect(() => {
      if (balance <= 0) {
        setErrorResponse('Balance is MYR 0, not allowed to submit claims');
      }

      if (limit !== null && limit <= 0) {
        setErrorResponse('Claim limit is MYR 0, not allowed to submit claims');
      }
    }, [limit, balance]);

  // Delete function
    const [showActions, setShowActions] = useState(false);

    const modalClick = (target) => {
      if (target.id !== 'more-actions-btn' && target.id !== 'arrow-down-icon') {
        setShowActions(false);
      }
    }

    const confirmDelete = (target) => {
      const confirmed = window.confirm('You are about to delete this claim. Confirm?');

      if (confirmed) {
        ClaimsService.deleteClaim(details.id).then(
          (data) => {
            props.triggerReload();
            setShow(false);
            alert('Claim Reference No. ' + details.id + ' was deleted.');
          },
          (error) => {
            console.log(error.response);

            if (error.response.status === 401) {
              AuthService.logout();
              window.location.replace('/eb/login');
            } else if (error.response.status === 404 || error.response.status === 410) {
              handleClose();
              alert('Claim ID: ' + details.id + ' not found. It may already be deleted');
              props.triggerReload();
            }
          }
        );
      }
    }

  return (
    <div>
      <img src={ MoreButton } alt="more-options" className="more-options d-block d-lg-none" onClick={ handleShow } />
      <button className="btn rounded-pill w-em-20 btn-outline-danger py-3 d-none d-lg-block" onClick={ handleShow } >Create Claim</button>

      <Modal show={ show } onHide={ handleClose } keyboard={ false } size="lg" dialogClassName="modal-70w" centered onClick={(e) => modalClick(e.target) }>
        <Modal.Header>
          <Modal.Title>Claim Details</Modal.Title>

          <span className="float-right position-relative font-size-4">
            <button id="more-actions-btn" className="btn btn-outline-danger rounded-pill px-4 py-2" onClick={() => setShowActions(!showActions) }>
              More Actions
              <img id="arrow-down-icon" src={ ArrowDown } alt="arrow-down" className="ml-3" />
            </button>

            <div id="claim-more-actions" className="conditional-display" displayed={ showActions.toString() }>
              <div className="action-child px-4 py-4" onClick={() => confirmDelete() }>Delete</div>
            </div>
          </span>

          <button type="button" className="close" onClick={ handleClose }>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3">
            <div className="row mb-6">
              { dateRefClaim(details, props.status, props.color) }
            </div>

            <h6 className="modal-section-header px-4 py-3 my-6">Medical Bill</h6>
            { medicalBill(details, props.category, balance) }

            {/* General Section */}
            <span className="conditional-display" displayed={ isGeneral.toString() }>
              <h6 className="modal-section-header px-4 py-3 my-6">Medical Cert</h6>
              <p><b>Number of Medical Cert Day(s)</b></p>

              <input name="leave-days" type="number" min="0" step="0.5"
                value={ leaveDays }
                onChange={(e) => setLeaveDays(e.target.value) }
                onBlur={(e) => settingCertDays(e.target.value) }
                className="form-control rounded-pill py-6 px-4 w-em-50"
              />

              <h6 className="modal-section-header px-4 py-3 my-6">Diagnoses / Diseases</h6>
              <p><b>Select an item to Add (Multiple selections are allowed)</b></p>

              <div className="async-select-container">
                <AsyncSelect cacheOptions defaultOptions loadOptions={ diagnosisOptions } onChange={(e) => onDiagnosisChange(e) } />
              </div>

              <div id="selected-diagnosis" className="mt-4">{ showDiagnosis }</div>

              <h6 className="modal-section-header px-4 py-3 my-6">Services / Procedures</h6>
              <p><b>Select an item to Add (Multiple selections are allowed)</b></p>

              <div className="async-select-container">
                <AsyncSelect cacheOptions defaultOptions loadOptions={ servicesOptions } onChange={(e) => onServicesChange(e) } />
              </div>

              <div id="selected-services" className="my-4">{ showServices }</div>

              <textarea name="doctor-note" type="area" rows="4"
                placeholder="Doctor's note (if any)"
                className="form-control py-3 px-4"
                value={ doctorNote }
                onChange={(e) => setDoctorNote(e.target.value) }
                style={{ borderRadius: "1em" }}
              />

              <h6 className="modal-section-header px-4 py-3 my-6">Medications</h6>
              <p><b>Select an item to Add (Multiple selections are allowed)</b></p>

              <div className="async-select-container">
                <AsyncSelect cacheOptions defaultOptions loadOptions={ medicationOptions } onChange={(e) => onMedicationChange(e) } />
              </div>

              <div id="selected-medications" className="mt-4">{ showMedication }</div>
            </span>

            {/* Optical Section */}
            <span className="conditional-display" displayed={ isOptical.toString() }>
              <h6 className="modal-section-header px-4 py-3 my-6">Eyewear</h6>
              <p><b>Select an item to Add (Multiple selections are allowed)</b></p>

              <div className="async-select-container">
                <AsyncSelect cacheOptions defaultOptions loadOptions={ eyewearsOptions } onChange={(e) => onEyewearsChange(e) } />
              </div>

              <div id="selected-services" className="my-4">{ showEyewears }</div>
            </span>

            <div className="d-flex justify-content-end align-items-baseline modal-section-header bg-grey px-4 py-5 my-6 font-size-7">
              <b className="fweight-500">Grand Total</b>
              <b className="fweight-400 ml-4">MYR</b>
              <span className="ml-6">{ grandTotal }</span>
            </div>
          </div>

          <div className="text-grey p-10 mb-10" style={{ backgroundColor: '#F9F9F9' }}>
            <p className="text-danger font-size-4"><b>Disclaimer</b></p>
            { disclaimer() }
          </div>

          <p className="text-danger fweight-400 mb-6 font-size-7 conditional-display" displayed={ (!!errorResponse).toString() }>
            <img src={ RedCheck } alt="red-check" className="w-em-3 mr-2" />
            { errorResponse }
          </p>

          <p className="text-success fweight-400 mb-6 font-size-7 conditional-display" displayed={ (!!successResponse).toString() }>
            <img src={ GreenTick } alt="green-tick" className="w-em-3 mr-2" />
            { successResponse }
          </p>

          <div className="d-flex justify-content-center conditional-display" displayed={ showButtons.toString() }>
            { displayDraft }
            { displaySubmit }
          </div>

          <div className="d-flex justify-content-center conditional-display" displayed={ (!showButtons).toString() }>
            <button className="btn rounded-pill w-em-26 btn-outline-danger py-3 ml-4" onClick={ handleClose }>Close</button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}